import React from "react"
import PropTypes from "prop-types"

const LhoActions = ({ children, className }) => {
  return (
    <div className={`lho-explorer-lho-actions ${className}`}>
      <div className="buttons">{children}</div>
    </div>
  )
}

LhoActions.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default LhoActions



// WEBPACK FOOTER //
// ./src/features/lho-explorer/LhoActions.js